<div fxLayout="row" fxLayoutAlign="space-between center">
    <div class="column">
      <h2 class="row" *ngIf="!this.modelId || this.modelId.length === 0">{{ "log-messages.title" | translate }}</h2>
      <mat-paginator
      [length]="totalElements"
      [pageSizeOptions]="[5, 10, 25, 9999]"
      [pageSize]="this.modelId || this.modelId.length === 0? this.defaultPageSize : 5"
      #paginator
      showFirstLastButtons
      (page)="this.handlePageEvent($event)"
    ></mat-paginator>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="end center"
      class="searchbox"
    >
      <app-table-search *ngIf="!this.modelId || this.modelId.length === 0" [allFields]="filterFields" (filterChangedEmitter)="filterchanged($event)" style="margin-right: 15px;"></app-table-search>
      <div *ngIf="topMenuIcons.length > 0">
        <button
          mat-raised-button
          *ngFor="let action of topMenuIcons"
          [routerLink]="action.routerLink"
          (click)="this[action.clickMethod]()"
        >
          <mat-icon [title]="action.title"> {{ action.icon }} </mat-icon>
        </button>
      </div>
      <button
        mat-raised-button
        (click)="exporter.exportTable('xlsx', {fileName:exportPrefix+formatted})">
        <mat-icon
          [title]="titleExcel">download
        </mat-icon>
      </button>
    </div>
  </div>

  <div class="top-table-sticky-header">
  <mat-table
    [dataSource]="dataSource"
    [paginator]="paginator"
    class="mat-elevation-z8"
    matSort
    [matSortActive]="this.defaultSort.active"
    [matSortDirection]="this.defaultSort.direction"
    matSortDisableClear
    appNgMatTableQueryReflector
    matTableExporter
    #exporter="matTableExporter"
    [hiddenColumns]="[0]"
  >
    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->
    <ng-container matColumnDef="id">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle">
        {{ "log-message.id" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("log-message.id" | translate) + ":"'>
         {{ element.id }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="author">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "log-message.author" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("log-message.author" | translate) + ":"'>
        {{ element.author ? element.author.displayName : '' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="created">
        <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
          {{ "log-message.creation-date" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("log-message.creation-date" | translate) + ":"'>
          {{ element.created | date : 'yyyy-MM-dd HH:mm' }}
        </mat-cell>
      </ng-container>

    <ng-container matColumnDef="lastModificationDate">
        <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
          {{ "log-message.modification-date" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("log-message.modification-date" | translate) + ":"'>
          {{ element.lastModificationDate | date : 'yyyy-MM-dd HH:mm' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="subject">
        <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
          {{ "log-message.subject" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("log-message.subject" | translate) + ":"'>
          {{ element.subject }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="messageModel">
        <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
          {{ "log-message.message-model" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("log-message.message-model" | translate) + ":"'>
          {{ element.messageModel }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="messageType">
        <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
          {{ "log-message.message-type" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("log-message.message-type" | translate) + ":"'>
          {{ element.messageType }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="modelId">
        <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
          {{ "log-message.model-id" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("log-message.model-id" | translate) + ":"'>
          {{ element.modelId }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="body">
        <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
          {{ "log-message.body" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("log-message.body" | translate) + ":"'>
          {{ element.body }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="startChainage">
        <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
          {{ "log-message.start-chainage" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("log-message.start-chainage" | translate) + ":"'>
          {{ element.startChainage }}
        </mat-cell>
      </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" class="one_actions"> </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title one_actions">
        <div *ngIf="actions.length > 0">
          <button
            class="icon-button"
            *ngFor="let action of actions"
            [routerLink]="action.routerLink + element.id"
            (click)="this[action.clickMethod](element.id)"
            [state]="{ listdata: listIds }"
          >
            <mat-icon [title]="action.title"> {{ action.icon }} </mat-icon>
          </button>
        </div>
      </mat-cell>
    </ng-container>


    <mat-header-row *matHeaderRowDef="displayedColumns;sticky:true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns" (click)="clickedRow(row.id)"
    [class.rowClicked]="clickedRowId == row.id"></mat-row>
  </mat-table>
  </div>





